import React, { Component } from 'react';
import { OcultarLlegendaSvg } from './LlegendaFooterIconsElement';

export class OcultarCapesLlegendaIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    return (
      <OcultarLlegendaSvg
        innerWidth={this.props.windowWidth}
        isHover={this.state.isButtonHovered}
        fontSizeEnabled={this.props.isFontSizeEnabled}
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}>
        <path
          className="Invisible-all"
          d="M102.4,3.4h308.3c54.5,0.1,98.7,44.3,98.8,98.8v308.3c-0.1,54.5-44.3,98.7-98.8,98.8H102.4c-54.5,0-98.7-44.2-98.8-98.7V102.2C3.7,47.7,47.9,3.5,102.4,3.4z M94.4,143.9l21-20.8l274,274l-20.8,21l-50.5-50.5c-18.8,6.2-38.8,9.5-59.8,9.5c-81.9,0-151.9-51-180.3-122.9c11.3-28.8,29.3-54.2,52.3-74.4L94.4,143.9 M258.3,205c27.2,0,49.2,22,49.2,49.2c0,5.7-1,11.3-2.8,16.4l-62.8-62.8C247,206,252.6,205,258.3,205 M258.3,131.3c81.9,0,151.9,51,180.3,122.9c-13.4,34.1-36.2,63.6-65.6,85.1l-23.3-23.4c22.3-15.4,40.6-36.4,53.1-61.6c-27-55.1-82.9-90.1-144.6-90.1c-17.9,0-35.4,2.9-51.8,8.2l-25.2-25.1C204.9,137,230.9,131.3,258.3,131.3 M113.8,254.2c27,55.1,82.9,90.1,144.5,90.1c11.3,0,22.5-1.1,32.8-3.4l-37.4-37.5c-23.4-2.5-42.1-21.1-44.6-44.6l-55.7-55.9C137.2,216.8,123.6,234.2,113.8,254.2z"
        />
      </OcultarLlegendaSvg>
    );
  };
}
